<marv-select 
    [label]="this.labelSelect" 
    [icon]="this.iconSelect" 
    [formName]="this.formName" 
    [items]="this.days" 
    [multiple]="this.multiple"
    [displayItemsSelected]="this.displayItemsSelected"
    [disabled]="this.disabled"
    [errorText]="this.errorText"
    [withSpeechToText]="this.withSpeechToText"
></marv-select>